module.exports = __webpack_public_path__ + "static/img/r-4-1.85050cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-4/r-4-1.png
// module id = W4tY
// module chunks = 0